

































































// Importing components
import BaseInputField from '@/ui/BaseInputField.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';

export default {
    name: 'TheFormProfile',
    components: {
        BaseInputField,
        BaseLoadingAnimation,
    },
    props: {
        userData: {
            type: Object,
            required: true,
        },
    },
    computed: {
        loading() {
            return this.$store.getters.loading;
        },
    },
    data() {
        return {};
    },
    methods: {
        onSubmit() {
            this.$emit('submit');
        },
    },
};
